import { render, staticRenderFns } from "./SalesByLocation.vue?vue&type=template&id=5685b329&scoped=true&"
import script from "./SalesByLocation.vue?vue&type=script&lang=js&"
export * from "./SalesByLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685b329",
  null
  
)

export default component.exports